import { NgModule } from '@angular/core';
import { NumberOnlyDirective } from './number-only.directive';

@NgModule({
  declarations: [NumberOnlyDirective],
  exports: [NumberOnlyDirective] // Export it so it can be used in other modules
})
export class NumberOnlyDirectiveModule { }